module.exports = __webpack_public_path__ + "static/media/first_page.5d39b0a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/first_page.svg
// module id = 1738
// module chunks = 0